export default __webpack_public_path__ + "475118238abafc6f234a71676fff7b59.png";